<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Generate B2B Gift Cards</h3>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-body">
                    <form @submit.prevent="submit">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Series Name</label>
                                    <input
                                        v-model="form.series_name"
                                        class="form-control"
                                        type="text"
                                        required
                                        :class="{ 'is-invalid': form.errors.series_name }"
                                    >
                                    <div v-if="form.errors.series_name" class="invalid-feedback d-block">
                                        {{ form.errors.series_name }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Amount (₦)</label>
                                    <input
                                        v-model="form.amount"
                                        class="form-control"
                                        type="number"
                                        min="1"
                                        required
                                        :class="{ 'is-invalid': form.errors.amount }"
                                    >
                                    <div v-if="form.errors.amount" class="invalid-feedback d-block">
                                        {{ form.errors.amount }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Quantity</label>
                                    <input
                                        v-model="form.quantity"
                                        class="form-control"
                                        type="number"
                                        min="1"
                                        max="500"
                                        required
                                        :class="{ 'is-invalid': form.errors.quantity }"
                                    >
                                    <div v-if="form.errors.quantity" class="invalid-feedback d-block">
                                        {{ form.errors.quantity }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Expiry Date & Time</label>
                                    <input
                                        v-model="form.expires_at"
                                        class="form-control"
                                        type="datetime-local"
                                        :min="minExpiryDateTime"
                                        :class="{ 'is-invalid': form.errors.expires_at }"
                                    >
                                    <small class="text-muted d-block">Optional. Must be in the future.</small>
                                    <div v-if="form.errors.expires_at" class="invalid-feedback d-block">
                                        {{ form.errors.expires_at }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <button class="btn btn-primary" type="submit" :disabled="saving">
                                    Generate
                                    <i v-if="saving" class="fa fa-spinner fa-spin"></i>
                                </button>
                                <Link :href="route('admin.pgc-giftcards.index')" class="btn btn-outline-secondary ml-1">
                                    Cancel
                                </Link>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import { Link } from '@inertiajs/vue2';

export default {
    layout: Layout,
    components: { Link },
    data() {
        return {
            saving: false,
            form: this.$inertia.form({
                series_name: '',
                amount: '',
                quantity: 1,
                expires_at: '',
            }),
        };
    },
    computed: {
        minExpiryDateTime() {
            const date = new Date();
            date.setMinutes(date.getMinutes() + 1);

            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${year}-${month}-${day}T${hours}:${minutes}`;
        },
    },
    mounted() {
        this.showErrorsAsToast(this.form.errors);
    },
    methods: {
        showErrorsAsToast(errors) {
            const messages = Object.values(errors || {}).flat().filter(Boolean);

            if (!messages.length) {
                return;
            }

            this.$page.props.flash.error = messages[0];
        },
        submit() {
            this.saving = true;

            this.form
                .transform((data) => ({
                    ...data,
                    expires_at: data.expires_at || null,
                }))
                .post(route('admin.pgc-giftcards.store'), {
                    preserveScroll: true,
                    onError: (errors) => {
                        this.showErrorsAsToast(errors);
                    },
                    onFinish: () => {
                        this.saving = false;
                    },
                });
        },
    },
};
</script>
